<template>
  <div>
    <v-container fluid class="card-flex-toolbar noPadding" scrollable style="width:100%;">

      <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
        <v-toolbar-title class="headline grey-text">Transfers</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip left>
          <v-btn v-on:click.prevent="$router.push({ path: '/dashboard/addtransfer' })"
                 slot="activator"
                 small
                 fab
                 flat
                 middle
                 right>
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <span>Add Budget</span>
        </v-tooltip>

        <!--Speed Dial-->
        <v-speed-dial v-model="speedDial"
                      :direction="direction"
                      :transition="transition">
          <v-btn slot="activator"
                 v-model="speedDial"
                 flat
                 small
                 fab>
            <v-icon>fas fa-ellipsis-v</v-icon>
            <v-icon>fas fa-times</v-icon>
          </v-btn>

          <!-- Search Button -->
          <v-tooltip left>
            <v-btn v-on:click.prevent="viewSearch = !viewSearch"
                   slot="activator"
                   fab
                   small
                   middle
                   right>
              <v-icon>fas fa-search</v-icon>
            </v-btn>
            <span>Search</span>
          </v-tooltip>
          <!--End Of Search Button-->
          <!-- Filter Button -->
          <v-tooltip left>
            <v-btn v-on:click.prevent="viewFilter = !viewFilter"
                   slot="activator"
                   fab
                   small
                   middle
                   right>
              <v-icon>fas fa-filter</v-icon>
            </v-btn>
            <span>Filter</span>
          </v-tooltip>
          <!-- End Of Filter Button -->

        </v-speed-dial>
        <!--End Of Speed Dial-->

      </v-toolbar>

      <v-container fluid style="min-height: 0;" v-bind:class="{'padContent': !drawer}" grid-list-lg>
        <v-layout row wrap>

          <!--Search Box-->
          <template v-if="viewSearch === true">
            <v-flex xs12>
              <v-text-field label="Search"
                            v-model="search"
                            @change="getSearchItems"
                            @input="getSearchItems"></v-text-field>
            </v-flex>
          </template>
          <!--End Of Search Box-->
          <!--Filter Box-->
          <template v-if="viewFilter === true">
            <v-flex xs12>

            </v-flex>
          </template>
          <!--End Of Filter Box-->

          <template v-if="itemsMinusDeleted.length === 0">
            <v-flex xs12>
              <v-card>
                <v-card-text class="text-xs-center">
                  <v-flex xs12>Sorry, There is currently no data to display here</v-flex>
                  <span><v-icon x-large>fas fa-frown</v-icon></span>
                </v-card-text>
              </v-card>
            </v-flex>
          </template>

          <ListItem v-for="itemMinus in itemsMinusDeleted" v-bind:liItem="{type: 'transfer',data: itemMinus}" :key="itemMinus.id" ref="listItem" v-on:Edit="redirectToEditPage($event)" v-on:Delete="DeleteTransfer($event)"></ListItem>

        </v-layout>
      </v-container>
    </v-container>

    <!-- Delete Transfer Dialog Box -->
    <v-layout row justify-center>
      <v-dialog v-model="deleteDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Delete</v-card-title>
          <v-card-text>Are you sure you want to delete <b>"{{deleteTransfer.transferName}}"</b>?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="deleteDialog = false">No</v-btn>
            <v-btn color="green darken-1" flat="flat" @click.native="DeleteTransferAccept()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End Of Delete Transfer Dialog Box -->

  </div>
</template>

<script>
  import listItem from '../reuseable/viewListItem/listItem.vue'
  import { transferManager } from '../../javascript/transferManager'

  export default {
    components: {
      'ListItem': listItem
    },
    props: ['drawer'],
    data() {
      return {
        direction: 'left',
        speedDial: false,
        transition: 'slide-y-reverse-transition',
        moreOptions: false,
        search: '',
        viewSearch: false,
        viewFilter: false,
        deleteDialog: false,
        deleteTransfer: {
          id: 0,
          currency: '',
          transferName: '',
          category: '',
          transferAmount: 0,
          comment: '',
          paymentType: '',

          transferFrom: '',
          transferTo: '',

          transferDate: '',
          transferTime: null,

          //State of Current Object
          objectState: ''
        },
        items: [],
        itemsMinusDeleted: []
      }
    },
    methods: {
      redirectToEditPage(item) {
        this.$router.push({ path: '/dashboard/edittransfer/' + item })
      },
      DeleteTransferAccept() {
        this.deleteDialog = false

        this.deleteTransfer.objectState = "Delete"

        ///Remove item from items array
        this.removeDeletedTransfersFromItems()

        transferManager.rollbackTransactionFromTransfer(this.deleteTransfer)

        this.$store.commit('markTransferAsDeleted', this.deleteTransfer)
      },
      DeleteTransfer(item) {
        for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
          if (this.itemsMinusDeleted[i].id === item) {
            this.deleteTransfer = this.itemsMinusDeleted[i]
            break
          }
        }

        this.deleteDialog = true
      },
      removeDeletedTransfersFromItems: function () {
       //Add Items if not Deleted

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].objectState !== 'Delete') {
            this.itemsMinusDeleted.push(this.items[i])
          }
        }

      },
      getitemsFromStoreAndRemoveDeletedItems: function () {
        this.items = JSON.parse(JSON.stringify(this.$store.state.Transfers))

        ///Remove deleted items from items array
        this.removeDeletedTransfersFromItems()
      }
    },
    beforeMount() {
      this.getitemsFromStoreAndRemoveDeletedItems()

      //let cat = this.$store.state.Categories
      //for (let i = 0; i < cat.length; i++) {
      //  this.category.push(cat[i].categoryName)
      //}

      //let acc = this.$store.state.Accounts
      //for (let i = 0; i < acc.length; i++) {
      //  this.account.push(acc[i].accountName)
      //}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/transfer/ViewTransfers.vue